// extracted by mini-css-extract-plugin
export default {"homeNossasSolucoes":"HomeNossasSolucoes_homeNossasSolucoes__eIiir","roundedShadowDiv":"HomeNossasSolucoes_roundedShadowDiv__7U7bD","divTitulo":"HomeNossasSolucoes_divTitulo__iEQuk"};